import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    var isDark = useTheme().isDark;
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 34 27"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.7019375,15.6173841 C11.9740294,15.6177719 12.2252462,15.7632888 12.360957,15.9991208 C12.4966677,16.2349528 12.4962547,16.5252714 12.3598736,16.7607164 C12.2234925,16.9961613 11.9718627,17.140963 11.6997708,17.1405767 C11.2791532,17.1399776 10.9386603,16.7985146 10.9392579,16.377897 C10.939857,15.9572795 11.2813199,15.6167865 11.7019375,15.6173841 M23.6447956,10.9080596 C23.3727037,10.9078659 23.1213837,10.7625278 22.9855053,10.5267925 C22.849627,10.2910573 22.8498335,10.0007387 22.986047,9.76519698 C23.1222606,9.52965527 23.3737871,9.3846748 23.6458789,9.38486813 C24.0664965,9.38516748 24.407232,9.72638793 24.406933,10.1470055 C24.4066336,10.5676231 24.0654132,10.9083586 23.6447956,10.9080596 M23.6447956,7.7923428 C22.3445472,7.79353733 21.2907857,8.84729884 21.2895912,10.1475472 C21.2895912,10.3999679 21.3318419,10.6513053 21.4141765,10.8961425 L13.6346352,15.0377922 C13.1967323,14.4019618 12.4739733,14.0223513 11.7019375,14.0226926 C10.8038398,14.0226926 9.98591005,14.5372842 9.58940369,15.3400471 L2.60070837,11.654488 C1.86186319,11.2666485 1.30935434,10.051129 1.36785528,8.94394459 C1.3981891,8.36651867 1.59752562,7.91801148 1.90194717,7.74467537 C2.09478359,7.6363403 2.32662064,7.64500711 2.5736246,7.77392584 L2.61912533,7.79884291 C4.47165501,8.77385853 10.5319188,11.966493 10.7875896,12.0845782 C11.1808459,12.2676645 11.3996827,12.3413324 12.0713601,12.0228273 L24.5992276,5.50755619 C24.7833972,5.43822174 24.9979006,5.26163558 24.9979006,4.99404796 C24.9979006,4.62354202 24.6143945,4.47728968 24.6133111,4.47728968 C23.9004664,4.13603421 22.8051988,3.62360933 21.737015,3.12310131 C19.4533118,2.05383418 16.865187,0.842648101 15.7287521,0.246805219 C14.7472363,-0.266703009 13.9574737,0.166637268 13.8166381,0.253305324 L13.5436337,0.38872416 C8.42805175,2.91834803 1.58127536,6.3092357 1.19126911,6.5464895 C0.494674618,6.97116298 0.0624176915,7.81725987 0.00608345545,8.86702669 C-0.0805846,10.5321367 0.767678993,12.2687479 1.98211512,12.9046747 L9.37273355,16.7159025 C9.54101744,17.8731201 10.5325486,18.7318322 11.7019375,18.7331015 C12.9872948,18.7309254 14.0342147,17.6999044 14.0560586,16.414731 L22.1963557,12.0022436 C22.608029,12.3250821 23.1204539,12.5016683 23.6447956,12.5016683 C24.945044,12.5004737 25.9988055,11.4467122 26,10.1464639 C25.9988055,8.84621549 24.945044,7.79245398 23.6447956,7.79125945",
                        id: "path-1"
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        x: "-26.9%",
                        y: "-26.7%",
                        width: "153.8%",
                        height: "174.7%",
                        filterUnits: "objectBoundingBox",
                        id: "filter-2",
                        children: [
                            /*#__PURE__*/ _jsx("feOffset", {
                                dx: "0",
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "2",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "兑换首页",
                    transform: "translate(-1860.000000, -459.000000)",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "icon1",
                        transform: "translate(1851.000000, 444.000000)",
                        children: /*#__PURE__*/ _jsxs("g", {
                            id: "swap_icon_shemei",
                            transform: "translate(13.000000, 17.000000)",
                            children: [
                                /*#__PURE__*/ _jsx("use", {
                                    fill: "black",
                                    fillOpacity: "1",
                                    filter: "url(#filter-2)",
                                    xlinkHref: "#path-1"
                                }),
                                /*#__PURE__*/ _jsx("use", {
                                    fill: isDark ? "#C3C9D0" : "#002236",
                                    fillRule: "evenodd",
                                    xlinkHref: "#path-1"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
